<template>
    <div :style="style">
        <Wp_grid_data
                :list="gridDatas"
                :column-num="column_num"
                :round="round"
                :radius="radius"
                :square="square"
                :icon="icon"
                :title="title"
                :title-style="title_style"
                :img-gray="imgGray"
                @clickItem="clickItem"

        ></Wp_grid_data>

        <van-popup
                v-model="showDetail"
                position="bottom"
                :style="{ width: '100%', height: '100%' }"
        >
            <Wp_jd_sku_detail_page v-if="skuInfoData && showDetail"
                                   type="popup"
                                   :datas="skuInfoData"
                                   @clickToCloseDetail="clickToCloseDetail"
            ></Wp_jd_sku_detail_page>
        </van-popup>
    </div>
</template>

<script>
    import Wp_jd_sku_detail_page from "../pages_childs/Wp_jd_sku_detail_page";
    import Wp_grid_data from "../custom/Wp_grid_data";
    export default {
        name: "Wp_home_grid_data_model",
        components: {Wp_grid_data, Wp_jd_sku_detail_page},

        inject: ['JdSelectListSheet_parent'],

        props:{
            params:{type: Object},
            imgGray:{type: Boolean, default: false}
        },

        data(){
            return{
                url: "",
                gridDatas: [],
                column_num: 3,
                round: false,
                radius: 0,
                square: false,
                icon:"",
                title: "",
                title_style: "",
                style: "",



                showDetail: false,

                skuInfoData: null,
            }
        },

        created() {
            this.initHotDatas();
        },

        methods:{
            initHotDatas(){
                if(this.params){
                    if(this.params.column_num){
                        this.column_num = this.params.column_num;
                    }
                    if(this.params.round){
                        this.round = this.params.round;
                    }
                    if(this.params.radius){
                        this.radius = this.params.radius;
                    }
                    if(this.params.square){
                        this.square = this.params.square;
                    }
                    if(this.params.icon){
                        this.icon = this.params.icon;
                    }
                    if(this.params.title){
                        this.title = this.params.title;
                    }
                    if(this.params.title_style){
                        this.title_style = this.params.title_style;
                    }
                    if(this.params.url){
                        this.url = this.params.url;

                        this.getHotDatas(null, datas=> {
                            this.gridDatas = datas;
                        })
                    }
                    if(this.params.style){
                        this.style = this.params.style;
                    }
                }
            },

            clickToCloseDetail(){
                this.showDetail = false;
            },

            getHotDatas(params, fn){
                this.$getDatasWithUrlAndParams(this.url, params, response=>{
                    if(response && response.code === 200){
                        if(fn){
                            fn(response.data);
                        }
                    }
                })
            },


            clickItem(item){
                //h5页面打开详情
                if(!this.$common.gloabl_wx_mini_user_info || !this.$common.gloabl_wx_mini_user_info.u_code){
                    // this.$common.static_skuInfo = item;
                    // this.$common.static_scroll_top = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
                    // this.$router.push('sku_detail');


                    let _skuInfo = item;
                    //添加一个时间戳，已保证如果是同一个商品，在详情页面也能通过watch监听到
                    _skuInfo.time_tag = new Date().getTime();

                    this.skuInfoData = _skuInfo;

                    this.showDetail = true;

                }else{
                    let _skuId = item.skuId;

                    if (_skuId) {
                        //小程序中，使用小程序的page打开详情
                        this.navigateToDetail(JSON.stringify(_skuId));
                    }
                }
            },

            /**
             * 打开小程序中的详情界面
             */
            navigateToDetail(sku_str) {
                this.$common.navigateToMiniProgramPage("../wp_detail/wp_detail?", "skuId", sku_str)
            },
        }
    }
</script>

<style scoped>

</style>